import { mainSiteUrl } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20workspace%20desk%20scene%20with%20laptop%20displaying%20colorful%20spreadsheet%20charts%20graphs%2C%20surrounded%20by%20curated%20fashion%20items%20shoes%20bags%20accessories%20arranged%20beautifully%2C%20warm%20natural%20sunlight%20streaming%20through%20window%2C%20cream%20beige%20neutral%20palette%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20aesthetic%2C%20lifestyle%20business%20concept%2C%20soft%20shadows%2C%20harmonious%20organized%20composition%2C%20no%20text%20no%20logos&width=1600&height=900&seq=hero-bg-v2-01&orientation=landscape"
          alt="Basetao Spreadsheet product organization concept"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 bg-accent-500/90 text-background-50 text-xs font-medium rounded-full mb-6 tracking-wide uppercase">
            Free Spreadsheet Resources
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
            Basetao Spreadsheet: The Ultimate Tool to Manage Orders, Costs &amp; Shipping
          </h1>
          <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Create, organize, and optimize your Basetao shopping workflow with professional spreadsheet templates, cost calculators, and expert guides — all in one place.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Get Free Basetao Spreadsheet
            </a>
            <Link
              to="/basetao-shopping-guide"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 text-white border border-white/30 font-medium text-sm rounded-md hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              Explore Shopping Guide
            </Link>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
            <span className="flex items-center gap-1.5 text-white/80 text-xs">
              <i className="ri-check-line text-accent-400"></i> Free Spreadsheet Resources
            </span>
            <span className="flex items-center gap-1.5 text-white/80 text-xs">
              <i className="ri-check-line text-accent-400"></i> Shipping Cost Tracking
            </span>
            <span className="flex items-center gap-1.5 text-white/80 text-xs">
              <i className="ri-check-line text-accent-400"></i> Order Management Templates
            </span>
            <span className="flex items-center gap-1.5 text-white/80 text-xs">
              <i className="ri-check-line text-accent-400"></i> Secure &amp; Private
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}